module.exports = __webpack_public_path__ + "img/BE0403236126.8d6bdd80.svg";